import React, { Component, Fragment } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Routes
} from "react-router-dom";
import HomePage from '../pages/HomePage';
import AllCoursePage from '../pages/AllCoursePage';
import AllProjectsPage from '../pages/AllProjectsPage';
import AboutPage from '../pages/AboutPage';
import ContactPage from '../pages/ContactPage';
import ProjectDetailsPage from '../pages/ProjectDetailsPage';
import CourseDetailsPage from '../pages/CourseDetailsPage';
import GalleryPage from '../pages/galleryPage';
import OrganizerPage from '../pages/OrganizerPage';
import VisitorPage from '../pages/VisitorPage';
import VendorRegistrationPage from '../pages/VendorRegistrationPage';

export class AppRouter extends Component {
  render() {
    return (
      <Fragment>

           <Routes>
          <Route excat path="/" Component={HomePage}> </Route>
          <Route excat path="/upcomingevents" Component={AllCoursePage}> </Route>
          <Route excat path="/events" Component={AllProjectsPage}> </Route>
          <Route excat path="/about" Component={AboutPage}> </Route>
         <Route excat path="/contact" Component={ContactPage}> </Route>
         <Route exact path="/projectdetails" Component={ProjectDetailsPage}> </Route>
         <Route exact path="/CourseDetails" Component={CourseDetailsPage}> </Route>
            <Route exact path="/galleryPage" Component={GalleryPage}> </Route>
             <Route exact path="/Organizer" Component={OrganizerPage}> </Route>
               <Route exact path="/visitorregistration" Component={VisitorPage}> </Route>
                 <Route exact path="/VendorRegistration" Component={VendorRegistrationPage}> </Route>
       
         
        </Routes>
        
      </Fragment>
    )
  }
}

export default AppRouter
